import { render, staticRenderFns } from "./EditTypeformForm.vue?vue&type=template&id=ec3d057e&"
import script from "./EditTypeformForm.vue?vue&type=script&lang=ts&"
export * from "./EditTypeformForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports